import { h } from '@stencil/core/internal/client';
import { t as text } from './parts.js';

const FormControlHelpText = (props) => {
    const { helpText, name } = props;
    if (!helpText) {
        return null;
    }
    return (h("small", { class: 'form-text text-muted', id: `form-help-text-${name}`, part: text }, helpText));
};

export { FormControlHelpText as F };
